module.exports = __webpack_public_path__ + "static/media/robot.b0881271.svg";